import type { OwaDate } from "../schema";
import { utcDate } from "./owaDate";
import { MIN_OUTLOOK_TIMESTAMP, MAX_OUTLOOK_TIMESTAMP } from "owa-date-constants";

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function utcDate called at module scope is not allowed. This may cause unwanted side effects. */
export const MIN_OUTLOOK_DATE: OwaDate = utcDate(MIN_OUTLOOK_TIMESTAMP);
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function utcDate called at module scope is not allowed. This may cause unwanted side effects. */
export const MAX_OUTLOOK_DATE: OwaDate = utcDate(MAX_OUTLOOK_TIMESTAMP);
